import { createFileRoute } from '@tanstack/react-router'
import { rosterEntry } from '@/lib/queries/roster-entries'
import { RosterPage } from '@/features/workspaces/roster'
import { rosterSearchSchema } from '@/features/workspaces/roster/roster-search-schema'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/workspace/$workspaceId/roster/'
)({
  validateSearch: rosterSearchSchema,
  staticData: { layout: 'fluid' },
  loader: ({ context, params }) =>
    context.queryClient.query(
      rosterEntry.findManyByWorkspace(params.workspaceId)
    ),
  component: RosterRouteComponent,
})

function RosterRouteComponent() {
  const { orgId, workspaceId } = Route.useParams()
  return <RosterPage orgId={orgId} workspaceId={workspaceId} />
}
